import { routesNames } from '@/core/constants'
import NaoAutorizado from '@/views/pages/comum/nao-autorizado/NaoAutorizado'
import PaginaNaoEncontrada from '@/views/pages/comum/pagina-nao-encontrada/PaginaNaoEncontrada'

export default [
	{
		path: '/',
		redirect: () => ({ name: routesNames.ATA.ATA_VIEW }),
	},
	{
		name: routesNames.COMUM.PAGINA_NAO_AUTORIZADO,
		path: '/403',
		component: NaoAutorizado,
		meta: {
			page: {
				title: 'Acesso Negado',
			},
		},
	},
	{
		name: routesNames.COMUM.PAGINA_NAO_ENCONTRADA,
		path: '*',
		component: PaginaNaoEncontrada,
		meta: {
			page: {
				title: 'Oops',
				subtitle: 'Página não encontrada',
			},
		},
	},
]
